import React from "react";

const QuickEditModal = ({
  quickset,
  setQuickSet,
  apiexercises,
  inputValues,
  handleInputsChange,
  handleQuickSaveSet,
}) => {
  if (!quickset) return null;

  return (
    <div className="excercise-modal">
      <div className="child-modal">
        <div className="add-excersie">
          <button className="button" onClick={() => handleQuickSaveSet()}>
            Save now
          </button>
          <i className="fa fa-times" onClick={() => setQuickSet(false)}></i>
        </div>

        {apiexercises?.map((exercise, exerciseIndex) => (
          <div key={exerciseIndex}>
            <h2
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                marginTop: "22px",
                background: "#ccc",
                padding: "5px",
              }}
            >
              {exercise.name}
            </h2>
            <ul className="sets-ul">
              {exercise.sets[0]?.inputs.map((input, inputIndex) => (
                <li key={inputIndex}>
                  <div className="left">
                    <span className="name">{input.field_name}</span>
                    <span className="value">{input.unit}</span>
                  </div>
                  <div className="rightt">
                    <input
                      type="number"
                      name={`${exercise.id}_${exercise.sets[0].id}_${input.id}`}
                      value={
                        inputValues[
                          `${exercise.id}_${exercise.sets[0].id}_${input.id}`
                        ] || ""
                      }
                      onChange={handleInputsChange}
                      min={0}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickEditModal;
